import MemberInviteDialog from './MemberInviteDialog';
import './style/member-invite-dialog.less';

export default MemberInviteDialog;
